<template>
    <div v-if="item.analytics && analyticsParams" :class="'campaign-analytics-component campaign-analytics-component-'+analyticsParams.mode">
        <div class="campaign-page-info" >
            <h4>
                <span v-if="analyticsParams.mode=='statistics'">Campaign Statistics <span style="font-weight: 100">({{ item.type }} campaign)</span></span>
                <span v-if="analyticsParams.mode=='analytics'">
                    Sales Campaign Analytics for
                    <b v-if="analyticsParams.userRange=='all'">All Team Members </b>
                    <b v-else-if="analyticsParams.userRange=='current'">Your Sales Only </b>
                    <span v-if="item.analytics.start_date && item.analytics.end_date" style="margin-left: 1px;" v-html="salesPeriod"></span>
                </span>


                <span class="simple-filters">
                    <select class="simple-filter-select" v-model="analyticsParams.userRange" style="width: 140px;" @change="analyticsFilter()">
                        <option value="all">All Team Members</option>
                        <option value="current">Only Your Sales</option>
                    </select>
                    <select class="simple-filter-select" v-model="analyticsParams.dateRange" :style="'width: '+(analyticsParams.dateRange=='custom'?'255':'200')+'px'" @change="analyticsFilter()">
                        <option value="month">Last 30 Days ({{ filterDates.monthAgo }} - {{ filterDates.today }})</option>
                        <option value="last-month">Last Full Month ({{ filterDates.monthFirst }} - {{ filterDates.monthLast }})</option>
                        <option value="mtd">Month To Date ({{ filterDates.monthFirst }} - {{ filterDates.today }})</option>
                        <option value="ytd">Year To Date (Jan 1 - {{ filterDates.today }})</option>
                        <option value="all-time">Since Launch ({{ filterDates.start }})</option>
                        <option value="custom">Custom Date Range <span v-if="filterDates.customStart && filterDates.customEnd"> ({{ filterDates.customStart }} - {{ filterDates.customEnd }})</span></option>
                        <option value="custom-new" v-if="analyticsParams.dateRange=='custom'">New Custom Date Range</option>
                    </select>
                </span>
                <!-- <a v-if="analyticsParams.mode=='statistics'" id="show-full-analytics-button" class="ws-button ws-button-secondary ws-button-small" :href="'/campaigns/' + item.id + '/analytics'">Show Full Campaign Analytics</a> -->
            </h4>

            <div class="campaign-page-stats" v-if="analyticsParams.mode=='statistics' && item.type=='sales'">
                <div class="campaign-page-stat" data-stat="sends">
                    <div class="stat-number">{{ item.analytics.sends }}</div>
                    <div class="stat-label">Total Sends</div>
                </div>
                <div class="campaign-page-stat" data-stat="opens">
                    <div class="stat-number">{{ item.analytics.opens }}<span v-if="parseInt(item.analytics.opens)"> ({{ (item.analytics.opens / item.analytics.sends * 100).toFixed(0) }}%)</span></div>
                    <div class="stat-label">Total Opens</div>
                </div>
                <div class="campaign-page-stat" data-stat="confirmed">
                    <div class="stat-number">{{ item.analytics.confirmed }}<span v-if="parseInt(item.analytics.confirmed)"> ({{ (item.analytics.confirmed / item.analytics.sends * 100).toFixed(0) }}%)</span></div>
                    <div class="stat-label">Total Redeems</div>
                </div>
                <div class="campaign-page-stat financial" data-stat="total-spent_ev">
                    <div class="stat-number">{{ item.analytics.spent_ev | toCurrency }}</div>
                    <div class="stat-number-2">{{ item.analytics.spent_iv | toCurrency }} inc. VAT</div>
                    <div class="stat-label">Total Spent</div>
                </div>
                <div class="campaign-page-stat financial" data-stat="influenced-opportunity">
                    <div class="stat-number">{{ item.analytics.opportunity_influenced | toCurrency }}</div>
                    <div class="stat-label">Influenced Opportunity</div>
                </div>
                <div class="campaign-page-stat highlight" data-stat="roi">
                    <div class="stat-number">{{ item.analytics.opportunity_roi }}x</div>
                    <div class="stat-label">ROI</div>
                </div>
            </div>
            <div class="campaign-page-stats" v-else-if="analyticsParams.mode=='statistics' && item.type=='reviews'">
                <div class="campaign-page-stat" data-stat="sends">
                    <div class="stat-number">{{ item.analytics.sends }}</div>
                    <div class="stat-label">Invitations</div>
                </div>
                <div class="campaign-page-stat" data-stat="reviews">
                    <div class="stat-number">{{ item.analytics.reviewed }}</div>
                    <div class="stat-label">Reviews</div>
                </div>
                <div class="campaign-page-stat highlight" data-stat="reviews-0">
                    <div class="stat-number">{{ item.analytics.reviews[0] }}<span v-if="parseInt(item.analytics.reviews[0])"> ({{ (item.analytics.reviews[0] / item.analytics.reviewed * 100).toFixed(0) }}%)</span></div>
                    <div class="stat-label"><b>{{ item.reviews.buttons[0] }}</b></div>
                </div>
                <div class="campaign-page-stat highlight" data-stat="reviews-1">
                    <div class="stat-number">{{ item.analytics.reviews[1] }}<span v-if="parseInt(item.analytics.reviews[1])"> ({{ (item.analytics.reviews[1] / item.analytics.reviewed * 100).toFixed(0) }}%)</span></div>
                    <div class="stat-label"><b>{{ item.reviews.buttons[1] }}</b></div>
                </div>
                <div class="campaign-page-stat negative" data-stat="reviews-2">
                    <div class="stat-number">{{ item.analytics.reviews[2] }}<span v-if="parseInt(item.analytics.reviews[2])"> ({{ (item.analytics.reviews[2] / item.analytics.reviewed * 100).toFixed(0) }}%)</span></div>
                    <div class="stat-label"><b>{{ item.reviews.buttons[2] }}</b></div>
                </div>
                <div class="campaign-page-stat negative" data-stat="reviews-3">
                    <div class="stat-number">{{ item.analytics.reviews[3] }}<span v-if="parseInt(item.analytics.reviews[3])"> ({{ (item.analytics.reviews[3] / item.analytics.reviewed * 100).toFixed(0) }}%)</span></div>
                    <div class="stat-label"><b>{{ item.reviews.buttons[3] }}</b></div>
                </div>
                <div class="campaign-page-stat financial" data-stat="total-spent_ev">
                    <div class="stat-number">{{ item.analytics.spent_ev | toCurrency }}</div>
                    <div class="stat-number-2">{{ item.analytics.spent_iv | toCurrency }} inc. VAT</div>
                    <div class="stat-label">Total Spent</div>
                </div>
            </div>
            <div class="campaign-page-stats" v-else-if="analyticsParams.mode=='statistics'">
                <div class="campaign-page-stat" data-stat="sends">
                    <div class="stat-number">{{ item.analytics.sends }}</div>
                    <div class="stat-label">Campaign Invitations</div>
                </div>
                <div class="campaign-page-stat" :class="item.analytics.for_confirmation?'highlight':''" data-stat="for_confirmation">
                    <div class="stat-number">{{ item.analytics.for_confirmation }}</div>
                    <div class="stat-label">For Confirmation</div>
                </div>
                <div class="campaign-page-stat" data-stat="confirmed">
                    <div class="stat-number">{{ item.analytics.confirmed }}</div>
                    <div class="stat-label">Confirmed Orders</div>
                </div>
                <div class="campaign-page-stat" data-stat="delivered">
                    <div class="stat-number">{{ item.analytics.delivered }}</div>
                    <div class="stat-label">Gifts Delivered</div>
                </div>
                <div class="campaign-page-stat negative" data-stat="rejected" v-if="item.analytics.rejected">
                    <div class="stat-number">{{ item.analytics.rejected }}</div>
                    <div class="stat-label">Rejected</div>
                </div>
                <div class="campaign-page-stat financial" data-stat="total-spent_ev">
                    <div class="stat-number">{{ item.analytics.spent_ev | toCurrency }}</div>
                    <div class="stat-number-2">{{ item.analytics.spent_iv | toCurrency }} inc. VAT</div>
                    <div class="stat-label">Total Spent</div>
                </div>
            </div>
            <div v-if="item.type=='sales' && !parseFloat(item.opportunity_value)" class="small-note error" style="margin-top: 20px; margin-bottom: 0">You didn't set <b>average opportunity value</b> for this campaign. <a class="ws-button small" style="font-weight: normal; margin-left: 5px" @click="openSalesSettings">Sales Metrics Settings</a></div>

            <div class="small-note" v-if="['new', 'requested'].includes(item.status)" style="margin-top: 20px; margin-bottom: 0"><b>Your campaign is waiting for confirmation.</b> You will be able to start sending invites to your campaign once your campaign request is processed by your <i>Account Manager</i>.</div>
        </div>

        <div id="campaign-analytics" v-if="analyticsParams.mode=='analytics'">
            <div id="analytics-left">
                <div class="analytics-row row-2" style="grid-template-columns: 5fr 4fr;">
                    <div class="analytics-box" id="analytics-box-redeems">
                        <div class="analytics-box-chart-head">
                            <div class="analytics-box-chart-head-left">
                                <h5>Opportunities Created</h5>
                                <em>{{ item.analytics.confirmed }}</em>
                                <p v-if="parseInt(item.analytics.confirmed)">Gift redeem rate: <b>{{ (item.analytics.confirmed / item.analytics.sends * 100).toFixed(0) }}%</b></p>
                            </div>
                            <div class="analytics-box-chart-head-right">
                                <doughnut-chart :width="100" :height="100" :chart-data="simpleDoughnutData('redeems')"></doughnut-chart>
                            </div>
                        </div>

                    </div>
                    <div class="analytics-box" id="analytics-box-opportunity_influenced">
                        <h5>Estimated Opportunity Value</h5>
                        <em>{{ item.analytics.opportunity_influenced | toCurrency }}</em>
                        <p>Based on <b>{{ item.analytics.opportunity_single | toCurrency }}</b> per opportunity</p>
                    </div>
                </div>
                <div class="analytics-row row-3">
                    <div class="analytics-box" id="analytics-box-sends">
                        <h5>Total Sends</h5>
                        <em>{{ item.analytics.sends }}</em>
                        <p v-if="parseInt(item.analytics.opens)">Open rate: <b>{{ (item.analytics.opens / item.analytics.sends * 100).toFixed(0) }}%</b> ({{ item.analytics.opens }} opens)</p>
                    </div>
                    <div class="analytics-box" id="analytics-box-spent_ev">
                        <h5>Total Spent</h5>
                        <em>{{ item.analytics.spent_ev | toCurrency }}</em>
                        <p>Gifts Value</p>
                    </div>
                    <div class="analytics-box" id="analytics-box-roi">
                        <h5>ROI</h5>
                        <em>{{ item.analytics.opportunity_roi }}x</em>
                        <p>Opportunity / Spent</p>
                    </div>
                </div>

                <div class="analytics-box" id="analytics-box-redeem-rate-chart">
                    <h5>
                        Invitations Send Rate
                        <span class="simple-filters">
                            <select class="simple-filter-select" v-model="analyticsParams.sendsChart.year" style="width: 60px;" @change="analyticsFilter(true)">
                                <option v-for="year in campaignYears" :value="year">{{ year }}</option>
                            </select>
                            <select class="simple-filter-select" v-model="analyticsParams.sendsChart.month" style="width: 90px;" @change="analyticsFilter(true)">
                                <option value="all">Full Year</option>
                                <option v-for="month in thisYear==analyticsParams.sendsChart.year?thisYearMonths:fullMonths" :value="month">{{ month }}</option>
                            </select>
                        </span>
                        <div class="chart-legend">
                            <div class="chart-legend-item"><em style="background-color: #7db2bd"></em> Sends</div>
                        </div>
                    </h5>
                    <line-chart :style="lineChartStyle" :chart-data="item.analytics.sends_chart_data" :custom-options="{year: analyticsParams.opensChart.year}"></line-chart>
                </div>
                <div class="analytics-box" id="analytics-box-redeem-rate-chart">
                    <h5>
                        Open & Redeem Rate
                        <span class="simple-filters">
                            <select class="simple-filter-select" v-model="analyticsParams.opensChart.year" style="width: 60px;" @change="analyticsFilter(true)">
                                <option v-for="year in campaignYears" :value="year">{{ year }}</option>
                            </select>
                            <select class="simple-filter-select" v-model="analyticsParams.opensChart.month" style="width: 90px;" @change="analyticsFilter(true)">
                                <option value="all">Full Year</option>
                                <option v-for="month in thisYear==analyticsParams.opensChart.year?thisYearMonths:fullMonths" :value="month">{{ month }}</option>
                            </select>
                        </span>
                        <div class="chart-legend">
                            <div class="chart-legend-item"><em style="background-color: #2f9cd5"></em> Opens</div>
                            <div class="chart-legend-item"><em style="background-color: #1d5997"></em> Redeems</div>
                        </div>
                    </h5>
                    <line-chart :style="lineChartStyle" :chart-data="item.analytics.opens_chart_data" :custom-options="{year: analyticsParams.opensChart.year}"></line-chart>
                </div>
                <div class="analytics-box" id="analytics-box-redeem-rate-chart">
                    <h5>
                        Spent vs. Oppportunity
                        <span class="simple-filters">
                            <select class="simple-filter-select" v-model="analyticsParams.spentChart.year" style="width: 60px;" @change="analyticsFilter(true)">
                                <option v-for="year in campaignYears" :value="year">{{ year }}</option>
                            </select>
                            <select class="simple-filter-select" v-model="analyticsParams.spentChart.month" style="width: 90px;" @change="analyticsFilter(true)">
                                <option value="all">Full Year</option>
                                <option v-for="month in thisYear==analyticsParams.spentChart.year?thisYearMonths:fullMonths" :value="month">{{ month }}</option>
                            </select>
                        </span>
                        <div class="chart-legend">
                            <div class="chart-legend-item"><em style="background-color: #e9c46a"></em> Spent</div>
                            <div class="chart-legend-item"><em style="background-color: #2a9d8f"></em> Opportunity</div>
                        </div>
                    </h5>
                    <line-chart :style="lineChartStyle" :chart-data="item.analytics.spent_chart_data" :custom-options="{year: analyticsParams.opensChart.year, valuePrepend: '£'}"></line-chart>
                </div>
            </div>

            <div id="analytics-right">
                <div class="analytics-box" id="analytics-box-team" v-if="item.analytics.batch/* && Object.keys(item.analytics.batch).length > 1*/">
                    <div class="analytics-box-chart-head">
                        <div class="analytics-box-chart-head-left">
                            <h5>Sales List Performance</h5>
                            <p>Performance of all lists <span v-html="salesPeriod"></span>. <i>If you add a new batch, it will appear here.</i></p>
                        </div>
                        <div class="analytics-box-chart-head-right">
                            <doughnut-chart :width="150" :height="150" :chart-data="item.analytics.batch_chart_data"></doughnut-chart>
                        </div>
                    </div>
                    <table class="worksends-table inset analytics-table">
                        <thead>
                            <tr>
                                <th class="field-name">List Name</th>
                                <th>Sends</th>
                                <th>Redeems</th>
                                <th class="financial">Spent</th>
                                <th v-tooltip="'Estimated Opportunity Value.'" class="financial">EOV</th>
                                <!-- <th class="financial">ROI</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="batch in item.analytics.batch" :batch-id="batch.id">
                                <td class="field-name"><div class="color-key" :style="'background-color: #'+batch.color"></div><div class="value">
                                    <div @click="openBatchDetailModal(batch.shared_secret)" style="color: #2f9cd5; cursor: pointer;">{{ batch.name }}</div>
                                </div></td>
                                <td><b>{{ batch.sends }}</b></td>
                                <td><b>{{ batch.redeems }}</b><span v-if="parseInt(batch.sends) && parseInt(batch.redeems)"> ({{ (batch.redeems / batch.sends * 100).toFixed(0) }}%)</span></td>
                                <td class="financial" :class="batch.spent_iv?'':'no-value'">{{ batch.spent_iv | toCurrency }}</td>
                                <td class="financial" :class="batch.redeems?'':'no-value'">{{ item.opportunity_value * batch.redeems | toCurrency }}</td>
                                <!-- <td class="financial"><b v-if="batch.spent_ev">{{ ((item.opportunity_value * batch.redeems) / batch.spent_ev ).toPrecision(2) }}x</b></td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="analytics-box" id="analytics-box-team" v-if="item.analytics.options/* && Object.keys(item.analytics.options).length > 1*/">
                    <div class="analytics-box-chart-head">
                        <div class="analytics-box-chart-head-left">
                            <h5>Gift Options Performance</h5>
                            <p>Redeem Performance of all campaign gift options <span v-html="salesPeriod"></span>. <i>If you add a new gift option, it will appear here.</i></p>
                        </div>
                        <div class="analytics-box-chart-head-right">
                            <doughnut-chart :width="150" :height="150" :chart-data="item.analytics.options_chart_data"></doughnut-chart>
                        </div>
                    </div>
                    <table class="worksends-table inset analytics-table">
                        <thead>
                            <tr>
                                <th class="field-name">Gift Option Name</th>
                                <th>Redeems</th>
                                <th>Rate</th>
                                <th class="financial">Spent</th>
                                <th v-tooltip="'Estimated Opportunity Value.'" class="financial">EOV</th>
                                <th class="financial">ROI</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="option in item.analytics.options" :option-id="option.id">
                                <td class="field-name"><div class="color-key" :style="'background-color: #'+option.color"></div><div class="value">{{ option.name }}</div></td>
                                <td><b>{{ option.redeems }}</b></td>
                                <td><b v-if="parseInt(option.redeems)">{{ (option.redeems / item.analytics.confirmed * 100).toFixed(0) }}%</b></td>
                                <td class="financial" :class="option.spent_iv?'':'no-value'">{{ option.spent_iv | toCurrency }}</td>
                                <td class="financial" :class="option.redeems?'':'no-value'">{{ item.opportunity_value * option.redeems | toCurrency }}</td>
                                <td class="financial"><b v-if="option.spent_iv">{{ ((item.opportunity_value * option.redeems) / option.spent_iv ).toPrecision(2) }}x</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="analytics-box" id="analytics-box-team" v-if="analyticsParams.userRange == 'all' && item.analytics.team/* && Object.keys(item.analytics.team).length > 1*/">
                    <div class="analytics-box-chart-head">
                        <div class="analytics-box-chart-head-left">
                            <h5>Team Members Statistics</h5>
                            <p>Statistics of all members of your team involved in this campaign <span v-html="salesPeriod"></span>. <i>If new team member gets involved, they will appear here.</i></p>
                        </div>
                        <div class="analytics-box-chart-head-right">
                            <doughnut-chart :width="150" :height="150" :chart-data="item.analytics.team_chart_data"></doughnut-chart>
                        </div>
                    </div>
                    <table class="worksends-table inset analytics-table">
                        <thead>
                            <tr>
                                <th class="field-name">Team Member</th>
                                <th>Sends</th>
                                <th>Redeems</th>
                                <th class="financial">Spent</th>
                                <th v-tooltip="'Estimated Opportunity Value.'" class="financial">EOV</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="member in item.analytics.team">
                                <td class="field-name"><div class="color-key" :style="'background-color: #'+member.color"></div><div class="value">{{ member.name }}</div></td>
                                <td><b>{{ member.sends }}</b></td>
                                <td><b>{{ member.redeems }}</b><span v-if="parseInt(member.sends) && parseInt(member.redeems)"> ({{ (member.redeems / member.sends * 100).toFixed(0) }}%)</span></td>
                                <td class="financial" :class="member.spent_iv?'':'no-value'">{{ member.spent_iv | toCurrency }}</td>
                                <td class="financial" :class="member.redeems?'':'no-value'">{{ item.opportunity_value * member.redeems | toCurrency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <date-range-modal v-if="modals.dateRangeModal" @set="onDateRangeSet" @close="onDateRangeNotSet"></date-range-modal>
<!--        <batch-detail-modal v-if="modals.batchDetailModal" :campaign-id="item.id" :batch-id="batchSecret" :batch-link="batchLink" @batch-renamed="batchRenamed" location="analytics"></batch-detail-modal>-->
    </div>
</template>


<script>
import DateRangeModal from "@/components/modals/DateRangeModal";
import DoughnutChart from "@/components/charts/DoughnutChart";
import LineChart from "@/components/charts/LineChart";
import BatchDetailModal from "@/pages/gift-box-campaigns/GiftBoxCampaignsBatchDetailModal";

export default {
    name: "GiftBoxCampaignAnalytics",
    components: {DateRangeModal,DoughnutChart,LineChart,BatchDetailModal},
    props: [ 'item', 'params' ],
    data() {
        return {
            analyticsParams: {
                mode: null,
                userRange: null,
				dateRange: null,
                customRange: null,
                sendsChart: {
                    year: null,
                    month: null,
                },
                opensChart: {
                    year: null,
                    month: null,
                },
                spentChart: {
                    year: null,
                    month: null,
                }
            },
			filterDates: {
				today: '',
				monthAgo: '',
				monthFirst: '',
				monthLast: '',
				start: '',
				customStart: '',
				customEnd: '',
			},
            shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            fullMonths: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            thisYear: null,
            thisYearMonths: [],
            // batchSecret: null,
			// batchLink: '',
            lineChartStyle: {
                width: '100%',
                height: '150px',
                position: 'relative'
            }
        }
    },
    methods: {
        async analyticsFilter(customSet = false) {
            if (this.analyticsParams.dateRange == 'custom-new') this.analyticsParams.dateRange = 'custom';
			if (this.analyticsParams.dateRange == 'custom' && !customSet) {
				this.modals.dateRangeModal = true;
				return;
			}
			if (this.analyticsParams.dateRange != 'custom') this.analyticsParams.customRange = null;

			await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', { campaignId: this.$route.params.id, params: {with_option_counts: true, analytics: this.analyticsParams}}, false, true);
			this.resetFilterDates();
		},
		onDateRangeSet(range) {
			this.analyticsParams.dateRange = 'custom';
			this.analyticsParams.customRange = range;
			this.analyticsFilter(true);
			this.modals.dateRangeModal = false;
		},
        onDateRangeNotSet() {
            this.analyticsParams.dateRange = 'month';
			this.analyticsParams.customRange = null;
            this.modals.dateRangeModal = false;
            this.analyticsFilter();
        },
		resetFilterDates() {
			const d = new Date();
			this.filterDates.today = this.shortMonths[d.getMonth()] + ' ' + d.getDate();
			d.setDate(d.getDate() - 30);
			this.filterDates.monthAgo = this.shortMonths[d.getMonth()] + ' ' + d.getDate();
			this.filterDates.monthFirst = this.shortMonths[d.getMonth()] + ' 1';

			const m = new Date(d.getFullYear(), d.getMonth() + 1, 0);
			this.filterDates.monthLast = this.shortMonths[d.getMonth()] + ' ' + m.getDate();

			const s = new Date(this.item.created_at);
			//this.filterDates.start = s.getDate() + ' ' + this.fullMonths[s.getMonth()] + ' ' + s.getFullYear();
            this.filterDates.start = this.shortMonths[s.getMonth()] + ' ' + s.getDate() + ', ' + s.getFullYear();
			if (this.analyticsParams.customRange) {
				if (this.analyticsParams.customRange.dateStart) {
					const cs = new Date(this.analyticsParams.customRange.dateStart);
					this.filterDates.customStart = this.shortMonths[cs.getMonth()] + ' ' + cs.getDate();
				}
				if (this.analyticsParams.customRange.dateEnd) {
					const ce = new Date(this.analyticsParams.customRange.dateEnd);
					this.filterDates.customEnd = this.shortMonths[ce.getMonth()] + ' ' + ce.getDate();
				}
			}
		},
        openSalesSettings() {
            this.$emit('configureSales');
        },
        simpleDoughnutData(type) {
            if (type == 'redeems') return {
                labels: ['Redeemed','Unclaimed'],
                datasets: [{
                    backgroundColor: ['#2a9d8f','#264653'],
                    data: [
                        parseInt((this.item.analytics.confirmed / this.item.analytics.sends * 100).toFixed(0)),
                        parseInt(100 - (this.item.analytics.confirmed / this.item.analytics.sends * 100).toFixed(0))
                    ]
                }]
            };
        },
        // openBatchDetailModal(sharedSecret) {
		// 	this.batchSecret = sharedSecret;
		// 	this.batchLink = this.item.registration_page+'?invite='+sharedSecret;
		// 	this.modals.batchDetailModal = true;
		// },
        batchRenamed(batch) {
			this.analyticsFilter();
            this.modals.batchDetailModal = false;
		},
    },
    mounted() {
        if (this.params) this.analyticsParams = this.params;
        this.resetFilterDates();
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
        salesPeriod() {
            return  'from <b>' + this.item.analytics.start_date + '</b> to <b>' + this.item.analytics.end_date + '</b>';
        },
        campaignYears() {
            const s = new Date(this.item.created_at);
            const f = new Date();
            var options = [];

            for (var i = 0; i!= parseInt(f.getFullYear())+1 - parseInt(s.getFullYear()); i++) {
                options.push(parseInt(f.getFullYear())-i);
            }
            return options;
        },
    },
    watch: {
		'item.created_at': {
			handler () {
				this.resetFilterDates();

                const s = new Date(this.item.created_at);
                this.thisYear = s.getFullYear();
                this.thisYearMonths = [...this.fullMonths];
                this.thisYearMonths.splice(0,s.getMonth());
			},
		}
	}
}
</script>
